import { fetchHasDismissedProperty } from '../../rest/fetch-has-dismissed-property/index.tsx';
import type { CmdbUpsellPageStoreAction } from '../../types.tsx';

export const fetchInitialState =
	(): CmdbUpsellPageStoreAction =>
	async ({ setState, getState }, { atlassianAccountId }) => {
		if (getState().userHasDismissed === undefined) {
			const userHasDismissed = await fetchHasDismissedProperty(atlassianAccountId);
			setState({ userHasDismissed });
		}
	};
